import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,_vm._g(_vm._b({staticClass:"text-uppercase",attrs:{"color":_vm.getPaymentStatusColor(),"text-color":"white","label":"","x-small":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.getPaymentStatusLabel()))])}
var staticRenderFns = []

export { render, staticRenderFns }